export const RESET_PASSWORD_BASE_ROUTE = '/reset-password'

export const SUBMIT_RESET_PASSWORD = 'SUBMIT_RESET_PASSWORD'
export const RESET_PASSWORD_SET_EMAIL = 'RESET_PASSWORD_SET_EMAIL'
export const RESET_PASSWORD_SET_CODE = 'RESET_PASSWORD_SET_CODE'
export const RESET_PASSWORD_SET_IS_LOADING = 'RESET_PASSWORD_SET_IS_LOADING'
export const RESET_PASSWORD_SET_SERVER_ERROR = 'RESET_PASSWORD_SET_SERVER_ERROR'
